/**
 * Static ATA code reference data for local development/fallback.
 * Sourced from my_glue_db.airtechmaintenance_atacodes (ata_code_id 178-607 for B738).
 * In production, data comes from the live API.
 */
import { AtaCodeRecord } from '../services/ataCodeService';

export const STATIC_ATA_CODES: AtaCodeRecord[] = [
  {
    ata_code_id: 178,
    ata_chapter: '0 - ADMINISTRATIVE',
    ata_sub_chapter: '0 - Administrative Task',
    description: '',
  },
  {
    ata_code_id: 179,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '0 - TIME LIMITS/MAINTENANCE CHECKS',
    description: '',
  },
  {
    ata_code_id: 180,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '41 - ZONAL INSPECTION PROGRAM',
    description: '',
  },
  {
    ata_code_id: 181,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '42 - ENHANCED ZONAL INSPECTION',
    description: '',
  },
  {
    ata_code_id: 182,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '51 - CONDITIONAL INSPECTIONS',
    description: '',
  },
  {
    ata_code_id: 183,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '55 - HIRF/LIGHTNING PROCEDURES',
    description: '',
  },
  {
    ata_code_id: 184,
    ata_chapter: '5 - TIME LIMITS - MAINTENANCE CHECKS',
    ata_sub_chapter: '56 - RESISTANCE',
    description: '',
  },
  {
    ata_code_id: 185,
    ata_chapter: '7 - LIFTING AND SHORING',
    ata_sub_chapter: '11 - AIRPLANE JACKING',
    description: '',
  },
  {
    ata_code_id: 186,
    ata_chapter: '7 - LIFTING AND SHORING',
    ata_sub_chapter: '12 - SHORING',
    description: '',
  },
  {
    ata_code_id: 187,
    ata_chapter: '8 - LEVELING AND WEIGHING',
    ata_sub_chapter: '11 - LEVELING',
    description: '',
  },
  {
    ata_code_id: 188,
    ata_chapter: '8 - LEVELING AND WEIGHING',
    ata_sub_chapter: '21 - WEIGHING',
    description: '',
  },
  {
    ata_code_id: 189,
    ata_chapter: '9 - TOWING AND TAXIING',
    ata_sub_chapter: '11 - TOWING',
    description: '',
  },
  {
    ata_code_id: 190,
    ata_chapter: '9 - TOWING AND TAXIING',
    ata_sub_chapter: '21 - TAXIING',
    description: '',
  },
  {
    ata_code_id: 191,
    ata_chapter: '10 - PARKING, MOORING, STORAGE AND RETURN TO SERVICE',
    ata_sub_chapter: '11 - PARKING/STORAGE',
    description: '',
  },
  {
    ata_code_id: 192,
    ata_chapter: '10 - PARKING, MOORING, STORAGE AND RETURN TO SERVICE',
    ata_sub_chapter: '21 - MOORING',
    description: '',
  },
  {
    ata_code_id: 193,
    ata_chapter: '10 - PARKING, MOORING, STORAGE AND RETURN TO SERVICE',
    ata_sub_chapter: '31 - RETURN TO SERVICE',
    description: '',
  },
  {
    ata_code_id: 194,
    ata_chapter: '11 - PLACARDS AND MARKINGS',
    ata_sub_chapter: '0 - PLACARDS AND MARKINGS',
    description: '',
  },
  {
    ata_code_id: 195,
    ata_chapter: '12 - SERVICING',
    ata_sub_chapter: '11 - REPLENISHING',
    description: '',
  },
  {
    ata_code_id: 196,
    ata_chapter: '12 - SERVICING',
    ata_sub_chapter: '21 - SCHEDULED SERVICING',
    description: '',
  },
  {
    ata_code_id: 197,
    ata_chapter: '12 - SERVICING',
    ata_sub_chapter: '31 - UNSCHEDULED SERVICING',
    description: '',
  },
  {
    ata_code_id: 198,
    ata_chapter: '20 - STANDARD PRACTICES - AIRFRAME',
    ata_sub_chapter: '0 - STANDARD PRACTICES - AIRFRAME',
    description: '',
  },
  {
    ata_code_id: 199,
    ata_chapter: '21 - AIR CONDITIONING',
    ata_sub_chapter: '0 - AIR CONDITIONING',
    description: '',
  },
  {
    ata_code_id: 200,
    ata_chapter: '21 - AIR CONDITIONING',
    ata_sub_chapter: '21 - CABIN AND COCKPIT AIR DISTRIBUTION',
    description: '',
  },
  {
    ata_code_id: 201,
    ata_chapter: '21 - AIR CONDITIONING',
    ata_sub_chapter: '31 - PRESSURIZATION CONTROL',
    description: '',
  },
  {
    ata_code_id: 202,
    ata_chapter: '21 - AIR CONDITIONING',
    ata_sub_chapter: '51 - RECIRCULATION AND FILTRATION',
    description: '',
  },
  {
    ata_code_id: 203,
    ata_chapter: '21 - AIR CONDITIONING',
    ata_sub_chapter: '61 - AIR CONDITIONING PACK',
    description: '',
  },
  {
    ata_code_id: 204,
    ata_chapter: '22 - AUTO FLIGHT',
    ata_sub_chapter: '0 - AUTO FLIGHT',
    description: '',
  },
  {
    ata_code_id: 205,
    ata_chapter: '22 - AUTO FLIGHT',
    ata_sub_chapter: '11 - AUTOPILOT',
    description: '',
  },
  {
    ata_code_id: 206,
    ata_chapter: '22 - AUTO FLIGHT',
    ata_sub_chapter: '21 - SPEED-ATTITUDE CORRECTION',
    description: '',
  },
  {
    ata_code_id: 207,
    ata_chapter: '22 - AUTO FLIGHT',
    ata_sub_chapter: '31 - AUTO THROTTLE',
    description: '',
  },
  {
    ata_code_id: 208,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '0 - COMMUNICATIONS',
    description: '',
  },
  {
    ata_code_id: 209,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '11 - HF COMMUNICATION',
    description: '',
  },
  {
    ata_code_id: 210,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '12 - VHF COMMUNICATION',
    description: '',
  },
  {
    ata_code_id: 211,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '15 - SATCOM',
    description: '',
  },
  {
    ata_code_id: 212,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '21 - DATA TRANSMISSION AUTO CALLING',
    description: '',
  },
  {
    ata_code_id: 213,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '41 - INTERPHONE',
    description: '',
  },
  {
    ata_code_id: 214,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '51 - AUDIO INTEGRATING',
    description: '',
  },
  {
    ata_code_id: 215,
    ata_chapter: '23 - COMMUNICATIONS',
    ata_sub_chapter: '71 - AUDIO/VIDEO MONITORING',
    description: '',
  },
  {
    ata_code_id: 216,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '0 - ELECTRICAL POWER',
    description: '',
  },
  {
    ata_code_id: 217,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '21 - AC GENERATION',
    description: '',
  },
  {
    ata_code_id: 218,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '22 - AC ELECTRICAL BUS',
    description: '',
  },
  {
    ata_code_id: 219,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '31 - DC GENERATION',
    description: '',
  },
  {
    ata_code_id: 220,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '32 - DC ELECTRICAL BUS',
    description: '',
  },
  {
    ata_code_id: 221,
    ata_chapter: '24 - ELECTRICAL POWER',
    ata_sub_chapter: '41 - EXTERNAL POWER',
    description: '',
  },
  {
    ata_code_id: 222,
    ata_chapter: '25 - EQUIPMENT/FURNISHINGS',
    ata_sub_chapter: '0 - EQUIPMENT/FURNISHINGS',
    description: '',
  },
  {
    ata_code_id: 223,
    ata_chapter: '25 - EQUIPMENT/FURNISHINGS',
    ata_sub_chapter: '11 - FLIGHT COMPARTMENT',
    description: '',
  },
  {
    ata_code_id: 224,
    ata_chapter: '25 - EQUIPMENT/FURNISHINGS',
    ata_sub_chapter: '21 - PASSENGER COMPARTMENT',
    description: '',
  },
  {
    ata_code_id: 225,
    ata_chapter: '25 - EQUIPMENT/FURNISHINGS',
    ata_sub_chapter: '51 - CARGO COMPARTMENT',
    description: '',
  },
  {
    ata_code_id: 226,
    ata_chapter: '25 - EQUIPMENT/FURNISHINGS',
    ata_sub_chapter: '61 - EMERGENCY EQUIPMENT',
    description: '',
  },
  {
    ata_code_id: 227,
    ata_chapter: '26 - FIRE PROTECTION',
    ata_sub_chapter: '0 - FIRE PROTECTION',
    description: '',
  },
  {
    ata_code_id: 228,
    ata_chapter: '26 - FIRE PROTECTION',
    ata_sub_chapter: '11 - DETECTION',
    description: '',
  },
  {
    ata_code_id: 229,
    ata_chapter: '26 - FIRE PROTECTION',
    ata_sub_chapter: '21 - EXTINGUISHING',
    description: '',
  },
  {
    ata_code_id: 230,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '0 - FLIGHT CONTROLS',
    description: '',
  },
  {
    ata_code_id: 231,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '11 - AILERON AND TAB',
    description: '',
  },
  {
    ata_code_id: 232,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '21 - RUDDER AND TAB',
    description: '',
  },
  {
    ata_code_id: 233,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '31 - ELEVATOR AND TAB',
    description: '',
  },
  {
    ata_code_id: 234,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '41 - HORIZONTAL STABILIZER',
    description: '',
  },
  {
    ata_code_id: 235,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '51 - TRAILING EDGE FLAPS',
    description: '',
  },
  {
    ata_code_id: 236,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '61 - SPOILERS/SPEED BRAKES',
    description: '',
  },
  {
    ata_code_id: 237,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '71 - LEADING EDGE DEVICES',
    description: '',
  },
  {
    ata_code_id: 238,
    ata_chapter: '27 - FLIGHT CONTROLS',
    ata_sub_chapter: '81 - AUGMENTATION',
    description: '',
  },
  { ata_code_id: 239, ata_chapter: '28 - FUEL', ata_sub_chapter: '0 - FUEL', description: '' },
  { ata_code_id: 240, ata_chapter: '28 - FUEL', ata_sub_chapter: '11 - STORAGE', description: '' },
  {
    ata_code_id: 241,
    ata_chapter: '28 - FUEL',
    ata_sub_chapter: '21 - DISTRIBUTION',
    description: '',
  },
  {
    ata_code_id: 242,
    ata_chapter: '28 - FUEL',
    ata_sub_chapter: '41 - INDICATING',
    description: '',
  },
  {
    ata_code_id: 243,
    ata_chapter: '29 - HYDRAULIC POWER',
    ata_sub_chapter: '0 - HYDRAULIC POWER',
    description: '',
  },
  {
    ata_code_id: 244,
    ata_chapter: '29 - HYDRAULIC POWER',
    ata_sub_chapter: '11 - MAIN SYSTEM',
    description: '',
  },
  {
    ata_code_id: 245,
    ata_chapter: '29 - HYDRAULIC POWER',
    ata_sub_chapter: '21 - AUXILIARY SYSTEM',
    description: '',
  },
  {
    ata_code_id: 246,
    ata_chapter: '29 - HYDRAULIC POWER',
    ata_sub_chapter: '31 - INDICATING',
    description: '',
  },
  {
    ata_code_id: 247,
    ata_chapter: '30 - ICE AND RAIN PROTECTION',
    ata_sub_chapter: '0 - ICE AND RAIN PROTECTION',
    description: '',
  },
  {
    ata_code_id: 248,
    ata_chapter: '30 - ICE AND RAIN PROTECTION',
    ata_sub_chapter: '11 - AIRFOIL',
    description: '',
  },
  {
    ata_code_id: 249,
    ata_chapter: '30 - ICE AND RAIN PROTECTION',
    ata_sub_chapter: '21 - AIR INTAKES',
    description: '',
  },
  {
    ata_code_id: 250,
    ata_chapter: '30 - ICE AND RAIN PROTECTION',
    ata_sub_chapter: '31 - PITOT/STATIC',
    description: '',
  },
  {
    ata_code_id: 251,
    ata_chapter: '30 - ICE AND RAIN PROTECTION',
    ata_sub_chapter: '41 - WINDOWS/WINDSHIELDS',
    description: '',
  },
  {
    ata_code_id: 252,
    ata_chapter: '31 - INDICATING/RECORDING SYSTEMS',
    ata_sub_chapter: '0 - INDICATING/RECORDING SYSTEMS',
    description: '',
  },
  {
    ata_code_id: 253,
    ata_chapter: '31 - INDICATING/RECORDING SYSTEMS',
    ata_sub_chapter: '21 - INDEPENDENT INSTRUMENTS',
    description: '',
  },
  {
    ata_code_id: 254,
    ata_chapter: '31 - INDICATING/RECORDING SYSTEMS',
    ata_sub_chapter: '31 - RECORDERS',
    description: '',
  },
  {
    ata_code_id: 255,
    ata_chapter: '31 - INDICATING/RECORDING SYSTEMS',
    ata_sub_chapter: '41 - CENTRAL COMPUTERS',
    description: '',
  },
  {
    ata_code_id: 256,
    ata_chapter: '31 - INDICATING/RECORDING SYSTEMS',
    ata_sub_chapter: '61 - INTEGRATED DISPLAY SYSTEM',
    description: '',
  },
  {
    ata_code_id: 257,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '0 - LANDING GEAR',
    description: '',
  },
  {
    ata_code_id: 258,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '11 - MAIN GEAR AND DOORS',
    description: '',
  },
  {
    ata_code_id: 259,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '21 - NOSE GEAR AND DOORS',
    description: '',
  },
  {
    ata_code_id: 260,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '31 - EXTENSION AND RETRACTION',
    description: '',
  },
  {
    ata_code_id: 261,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '41 - WHEELS AND BRAKES',
    description: '',
  },
  {
    ata_code_id: 262,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '51 - STEERING',
    description: '',
  },
  {
    ata_code_id: 263,
    ata_chapter: '32 - LANDING GEAR',
    ata_sub_chapter: '61 - POSITION AND WARNING',
    description: '',
  },
  { ata_code_id: 264, ata_chapter: '33 - LIGHTS', ata_sub_chapter: '0 - LIGHTS', description: '' },
  {
    ata_code_id: 265,
    ata_chapter: '33 - LIGHTS',
    ata_sub_chapter: '11 - FLIGHT COMPARTMENT',
    description: '',
  },
  {
    ata_code_id: 266,
    ata_chapter: '33 - LIGHTS',
    ata_sub_chapter: '21 - PASSENGER COMPARTMENT',
    description: '',
  },
  {
    ata_code_id: 267,
    ata_chapter: '33 - LIGHTS',
    ata_sub_chapter: '41 - EXTERIOR LIGHTING',
    description: '',
  },
  {
    ata_code_id: 268,
    ata_chapter: '33 - LIGHTS',
    ata_sub_chapter: '51 - EMERGENCY LIGHTING',
    description: '',
  },
  {
    ata_code_id: 269,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '0 - NAVIGATION',
    description: '',
  },
  {
    ata_code_id: 270,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '11 - FLIGHT ENVIRONMENT DATA',
    description: '',
  },
  {
    ata_code_id: 271,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '21 - ATTITUDE AND DIRECTION',
    description: '',
  },
  {
    ata_code_id: 272,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '31 - LANDING AND TAXIING AIDS',
    description: '',
  },
  {
    ata_code_id: 273,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '41 - INDEPENDENT POSITION DETERMINING',
    description: '',
  },
  {
    ata_code_id: 274,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '51 - DEPENDENT POSITION DETERMINING',
    description: '',
  },
  {
    ata_code_id: 275,
    ata_chapter: '34 - NAVIGATION',
    ata_sub_chapter: '61 - FLIGHT MANAGEMENT COMPUTING',
    description: '',
  },
  { ata_code_id: 276, ata_chapter: '35 - OXYGEN', ata_sub_chapter: '0 - OXYGEN', description: '' },
  { ata_code_id: 277, ata_chapter: '35 - OXYGEN', ata_sub_chapter: '11 - CREW', description: '' },
  {
    ata_code_id: 278,
    ata_chapter: '35 - OXYGEN',
    ata_sub_chapter: '21 - PASSENGER',
    description: '',
  },
  {
    ata_code_id: 279,
    ata_chapter: '36 - PNEUMATIC',
    ata_sub_chapter: '0 - PNEUMATIC',
    description: '',
  },
  {
    ata_code_id: 280,
    ata_chapter: '36 - PNEUMATIC',
    ata_sub_chapter: '11 - DISTRIBUTION',
    description: '',
  },
  {
    ata_code_id: 281,
    ata_chapter: '36 - PNEUMATIC',
    ata_sub_chapter: '21 - INDICATING',
    description: '',
  },
  {
    ata_code_id: 282,
    ata_chapter: '38 - WATER/WASTE',
    ata_sub_chapter: '0 - WATER/WASTE',
    description: '',
  },
  {
    ata_code_id: 283,
    ata_chapter: '38 - WATER/WASTE',
    ata_sub_chapter: '11 - POTABLE WATER',
    description: '',
  },
  {
    ata_code_id: 284,
    ata_chapter: '38 - WATER/WASTE',
    ata_sub_chapter: '21 - WASH WATER',
    description: '',
  },
  {
    ata_code_id: 285,
    ata_chapter: '38 - WATER/WASTE',
    ata_sub_chapter: '31 - WASTE DISPOSAL',
    description: '',
  },
  {
    ata_code_id: 286,
    ata_chapter: '49 - AIRBORNE AUXILIARY POWER',
    ata_sub_chapter: '0 - AIRBORNE AUXILIARY POWER',
    description: '',
  },
  {
    ata_code_id: 287,
    ata_chapter: '49 - AIRBORNE AUXILIARY POWER',
    ata_sub_chapter: '11 - POWER PLANT',
    description: '',
  },
  {
    ata_code_id: 288,
    ata_chapter: '49 - AIRBORNE AUXILIARY POWER',
    ata_sub_chapter: '21 - ENGINE',
    description: '',
  },
  {
    ata_code_id: 289,
    ata_chapter: '49 - AIRBORNE AUXILIARY POWER',
    ata_sub_chapter: '31 - ENGINE FUEL AND CONTROL',
    description: '',
  },
  { ata_code_id: 290, ata_chapter: '52 - DOORS', ata_sub_chapter: '0 - DOORS', description: '' },
  {
    ata_code_id: 291,
    ata_chapter: '52 - DOORS',
    ata_sub_chapter: '11 - PASSENGER/CREW DOORS',
    description: '',
  },
  {
    ata_code_id: 292,
    ata_chapter: '52 - DOORS',
    ata_sub_chapter: '21 - EMERGENCY EXIT',
    description: '',
  },
  {
    ata_code_id: 293,
    ata_chapter: '52 - DOORS',
    ata_sub_chapter: '31 - CARGO DOORS',
    description: '',
  },
  {
    ata_code_id: 294,
    ata_chapter: '52 - DOORS',
    ata_sub_chapter: '41 - SERVICE DOORS',
    description: '',
  },
  {
    ata_code_id: 295,
    ata_chapter: '53 - FUSELAGE',
    ata_sub_chapter: '0 - FUSELAGE',
    description: '',
  },
  {
    ata_code_id: 296,
    ata_chapter: '54 - NACELLES/PYLONS',
    ata_sub_chapter: '0 - NACELLES/PYLONS',
    description: '',
  },
  {
    ata_code_id: 297,
    ata_chapter: '55 - STABILIZERS',
    ata_sub_chapter: '0 - STABILIZERS',
    description: '',
  },
  {
    ata_code_id: 298,
    ata_chapter: '56 - WINDOWS',
    ata_sub_chapter: '0 - WINDOWS',
    description: '',
  },
  { ata_code_id: 299, ata_chapter: '57 - WINGS', ata_sub_chapter: '0 - WINGS', description: '' },
  {
    ata_code_id: 300,
    ata_chapter: '71 - POWER PLANT',
    ata_sub_chapter: '0 - POWER PLANT',
    description: '',
  },
  {
    ata_code_id: 301,
    ata_chapter: '71 - POWER PLANT',
    ata_sub_chapter: '11 - COWLING',
    description: '',
  },
  {
    ata_code_id: 302,
    ata_chapter: '71 - POWER PLANT',
    ata_sub_chapter: '21 - ENGINE MOUNTS',
    description: '',
  },
  {
    ata_code_id: 303,
    ata_chapter: '71 - POWER PLANT',
    ata_sub_chapter: '61 - AIR INTAKE',
    description: '',
  },
  {
    ata_code_id: 304,
    ata_chapter: '71 - POWER PLANT',
    ata_sub_chapter: '71 - ENGINE DRAINS',
    description: '',
  },
  { ata_code_id: 305, ata_chapter: '72 - ENGINE', ata_sub_chapter: '0 - ENGINE', description: '' },
  {
    ata_code_id: 306,
    ata_chapter: '72 - ENGINE',
    ata_sub_chapter: '31 - COMPRESSOR SECTION',
    description: '',
  },
  {
    ata_code_id: 307,
    ata_chapter: '72 - ENGINE',
    ata_sub_chapter: '41 - COMBUSTION SECTION',
    description: '',
  },
  {
    ata_code_id: 308,
    ata_chapter: '72 - ENGINE',
    ata_sub_chapter: '51 - TURBINE SECTION',
    description: '',
  },
  {
    ata_code_id: 309,
    ata_chapter: '73 - ENGINE FUEL AND CONTROL',
    ata_sub_chapter: '0 - ENGINE FUEL AND CONTROL',
    description: '',
  },
  {
    ata_code_id: 310,
    ata_chapter: '73 - ENGINE FUEL AND CONTROL',
    ata_sub_chapter: '11 - DISTRIBUTION',
    description: '',
  },
  {
    ata_code_id: 311,
    ata_chapter: '73 - ENGINE FUEL AND CONTROL',
    ata_sub_chapter: '21 - CONTROLLING',
    description: '',
  },
  {
    ata_code_id: 312,
    ata_chapter: '73 - ENGINE FUEL AND CONTROL',
    ata_sub_chapter: '31 - INDICATING',
    description: '',
  },
  {
    ata_code_id: 313,
    ata_chapter: '74 - IGNITION',
    ata_sub_chapter: '0 - IGNITION',
    description: '',
  },
  { ata_code_id: 314, ata_chapter: '75 - AIR', ata_sub_chapter: '0 - AIR', description: '' },
  {
    ata_code_id: 315,
    ata_chapter: '75 - AIR',
    ata_sub_chapter: '11 - ENGINE ANTI-ICING',
    description: '',
  },
  { ata_code_id: 316, ata_chapter: '75 - AIR', ata_sub_chapter: '21 - COOLING', description: '' },
  {
    ata_code_id: 317,
    ata_chapter: '76 - ENGINE CONTROLS',
    ata_sub_chapter: '0 - ENGINE CONTROLS',
    description: '',
  },
  {
    ata_code_id: 318,
    ata_chapter: '76 - ENGINE CONTROLS',
    ata_sub_chapter: '11 - POWER CONTROL',
    description: '',
  },
  {
    ata_code_id: 319,
    ata_chapter: '77 - ENGINE INDICATING',
    ata_sub_chapter: '0 - ENGINE INDICATING',
    description: '',
  },
  {
    ata_code_id: 320,
    ata_chapter: '77 - ENGINE INDICATING',
    ata_sub_chapter: '11 - POWER',
    description: '',
  },
  {
    ata_code_id: 321,
    ata_chapter: '77 - ENGINE INDICATING',
    ata_sub_chapter: '21 - TEMPERATURE',
    description: '',
  },
  {
    ata_code_id: 322,
    ata_chapter: '78 - EXHAUST',
    ata_sub_chapter: '0 - EXHAUST',
    description: '',
  },
  {
    ata_code_id: 323,
    ata_chapter: '78 - EXHAUST',
    ata_sub_chapter: '31 - THRUST REVERSER',
    description: '',
  },
  { ata_code_id: 324, ata_chapter: '79 - OIL', ata_sub_chapter: '0 - OIL', description: '' },
  { ata_code_id: 325, ata_chapter: '79 - OIL', ata_sub_chapter: '11 - STORAGE', description: '' },
  {
    ata_code_id: 326,
    ata_chapter: '79 - OIL',
    ata_sub_chapter: '21 - DISTRIBUTION',
    description: '',
  },
  {
    ata_code_id: 327,
    ata_chapter: '79 - OIL',
    ata_sub_chapter: '31 - INDICATING',
    description: '',
  },
  {
    ata_code_id: 328,
    ata_chapter: '80 - STARTING',
    ata_sub_chapter: '0 - STARTING',
    description: '',
  },
  {
    ata_code_id: 329,
    ata_chapter: '80 - STARTING',
    ata_sub_chapter: '11 - CRANKING',
    description: '',
  },
];
